import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TwinAssetsKeyType {
  plural: LocalesKey;
  upload: LocalesKey;
  createTitle: LocalesKey;
  editTitle: LocalesKey;
  deleteTitle: LocalesKey;
  deleteWarning: LocalesKey;
  deleteInUse: LocalesKey;
  columns: {
    name: LocalesKey;
    assetType: LocalesKey;
    company: LocalesKey;
    mimeType: LocalesKey;
    createdAt: LocalesKey;
  };
  profile: {
    title: LocalesKey;
    parsedAt: LocalesKey;
    parsedNotSaved: LocalesKey;
    isFrameOnly: LocalesKey;
    warnings: LocalesKey;
    mountCorrection: LocalesKey;
    mountCorrectionHint: LocalesKey;
    applyMountCorrection: LocalesKey;
    sockets: LocalesKey;
    connectors: LocalesKey;
    zones: LocalesKey;
    materials: LocalesKey;
    reparse: LocalesKey;
    parse: LocalesKey;
    noProfileYet: LocalesKey;
  };
  overrides: {
    open: LocalesKey;
    title: LocalesKey;
    meshesTitle: LocalesKey;
    meshZoneColumn: LocalesKey;
    noZone: LocalesKey;
    customZone: LocalesKey;
    customZoneHint: LocalesKey;
    nodesTitle: LocalesKey;
    markColumn: LocalesKey;
    group: LocalesKey;
    position: LocalesKey;
    kind: LocalesKey;
    save: LocalesKey;
    reuploadNote: LocalesKey;
    loadError: LocalesKey;
  };
}

export const twinAssetsKeys = keyPathMirror<TwinAssetsKeyType, string>(
  {
    plural: null,
    upload: null,
    createTitle: null,
    editTitle: null,
    deleteTitle: null,
    deleteWarning: null,
    deleteInUse: null,
    columns: {
      name: null,
      assetType: null,
      company: null,
      mimeType: null,
      createdAt: null
    },
    profile: {
      title: null,
      parsedAt: null,
      parsedNotSaved: null,
      isFrameOnly: null,
      warnings: null,
      mountCorrection: null,
      mountCorrectionHint: null,
      applyMountCorrection: null,
      sockets: null,
      connectors: null,
      zones: null,
      materials: null,
      reparse: null,
      parse: null,
      noProfileYet: null
    },
    overrides: {
      open: null,
      title: null,
      meshesTitle: null,
      meshZoneColumn: null,
      noZone: null,
      customZone: null,
      customZoneHint: null,
      nodesTitle: null,
      markColumn: null,
      group: null,
      position: null,
      kind: null,
      save: null,
      reuploadNote: null,
      loadError: null
    }
  },
  'models.twinAssets.'
);
